<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .duration {
    @include mixins.body2();
  }
</style>

<script>
  import { timestampToDuration } from "@sourcewhale/shared/src/assets/js/src/general/utils";

  let { duration, skeleton = false } = $props();

  let formattedDuration = $derived(timestampToDuration(duration || 0));
</script>

<span class="duration" class:skeleton>{formattedDuration}</span>
